import { render } from "./RunBoard.vue?vue&type=template&id=56c5838e&scoped=true&ts=true"
import script from "./RunBoard.vue?vue&type=script&lang=ts"
export * from "./RunBoard.vue?vue&type=script&lang=ts"

import "./RunBoard.vue?vue&type=style&index=0&id=56c5838e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c5838e"]])

export default __exports__